
import List from '@/components/List/List';
export default {
  components: {
    List,
  },
};
